/**
 * API のエラー（03 3.4.7）。code は応答の error.code。Authorizer の 401（{"message":"Unauthorized"}）は AUTH_004 とみなす。
 * 通信できないときは NETWORK、30 秒の打ち切りは TIMEOUT（画面の中だけのコード）。
 */
export class ApiError extends Error {
  constructor(
    readonly status: number,
    readonly code: string,
    readonly details: unknown,
    readonly trace_id: string | undefined,
    message: string,
  ) {
    super(message);
    this.name = 'ApiError';
  }
}

export function isApiError(error: unknown): error is ApiError {
  return error instanceof ApiError;
}
